import React from 'react';
import intl from 'react-intl-universal';
import { nucleusConstants } from '@lifesize/nucleus';
import { Button, Checkbox, Form as uiForm } from 'semantic-ui-react';
import { Formik, Form } from 'formik';
import get from 'lodash/get';
import * as styles from 'components/Settings/Sections.scss';
import * as screen_main_only from '../../../images/screen_main_only.svg';
import * as screen_main_plus_4 from '../../../images/screen_main_plus_4.svg';
import * as screen_main_plus_7 from '../../../images/screen_main_plus_7.svg';
import * as screen_main_plus_12 from '../../../images/screen_main_plus_12.svg';
import * as screen_tiles_2 from '../../../images/screen_tiles_2.svg';
import * as screen_tiles_3 from '../../../images/screen_tiles_3.svg';
import * as screen_tiles_4 from '../../../images/screen_tiles_4.svg';

const defaultLayout = nucleusConstants.MEETING_LAYOUT_TYPES.ALTERNATIVE;
const defaultOptionId = 0;

// props passed in
export interface OwnProps {
  selectedLayout: number;
  updateSection: Function;
}

class MeetingLayouts extends React.PureComponent<OwnProps> {
  // tslint:disable-next-line:no-any
  private readonly formik = React.createRef<any>();

  componentDidMount() {
    const initialValues = this.formik.current.initialValues;
    // if there is no meetingLayout selected, auto-select TILES so the form is 'dirty'
    if (initialValues.meetingLayout === defaultOptionId) {
      this.formik.current.setValues({
        meetingLayout: defaultLayout
      });
    }
  }

  onSubmit = (formData: object, callback: Function) => {
    this.props.updateSection(get(formData, 'meetingLayout'), callback);
  }

  render() {
    const { selectedLayout } = this.props;
    return (
      <section className={styles.container} data-test="settingsSection.layout">
        <article>
          <h6 className={styles.title} data-test="sectionTitle">{intl.get('settingsSectionTitleMeetingLayouts')}</h6>
          <p className={styles.description}>{intl.get('settingsSectionDescriptionMeetingLayouts')}</p>
          <Formik
            ref={this.formik}
            enableReinitialize={true}
            initialValues={{
              meetingLayout: selectedLayout || defaultOptionId,
            }}
            onSubmit={(formData, { setSubmitting }) => this.onSubmit(formData, () => setSubmitting(false))}
            render={({dirty, errors, isSubmitting, setFieldValue, touched, values}) => (
              <Form>
                <div className={styles.formSection}>
                  <uiForm.Field className={styles.optionGroup}>
                    <Checkbox
                      checked={values.meetingLayout === nucleusConstants.MEETING_LAYOUT_TYPES.DEFAULT}
                      label={intl.get('inputLabelOption1')}
                      name="meetingLayout"
                      onChange={() => setFieldValue('meetingLayout', nucleusConstants.MEETING_LAYOUT_TYPES.DEFAULT)}
                      radio={true}
                      value={nucleusConstants.MEETING_LAYOUT_TYPES.DEFAULT}
                    />
                  </uiForm.Field>
                  <div className={styles.layoutImages}>
                    <img src={screen_main_only} />
                    <img src={screen_main_plus_4} />
                    <img src={screen_main_plus_7} />
                    <img src={screen_main_plus_12} />
                  </div>
                  <uiForm.Field className={styles.optionGroup}>
                    <Checkbox
                      checked={values.meetingLayout === nucleusConstants.MEETING_LAYOUT_TYPES.ALTERNATIVE}
                      label={intl.get('inputLabelOption2')}
                      name="meetingLayout"
                      onChange={() => setFieldValue('meetingLayout', nucleusConstants.MEETING_LAYOUT_TYPES.ALTERNATIVE)}
                      radio={true}
                      value={nucleusConstants.MEETING_LAYOUT_TYPES.ALTERNATIVE}
                    />
                  </uiForm.Field>
                  <div className={styles.layoutImages}>
                    <img src={screen_main_only} />
                    <img src={screen_tiles_2} />
                    <img src={screen_tiles_3} />
                    <img src={screen_tiles_4} />
                    <img src={screen_main_plus_7} />
                    <img src={screen_main_plus_12} />
                  </div>
                  <div className={styles.buttonContainer}>
                    <Button
                      data-test="sectionBtnSubmit"
                      disabled={isSubmitting || !dirty}
                      name="btnSubmitMeetingLayout"
                      role="button"
                      type="submit"
                    >
                      {intl.get('settingsButtonLabelUpdate')}
                    </Button>
                  </div>
                </div>
              </Form>
            )}
          />
        </article>
      </section>
    );
  }
}

export default MeetingLayouts;
